import { render, staticRenderFns } from "./BalanceRefund.vue?vue&type=template&id=0baf0bbe&"
import script from "./BalanceRefund.vue?vue&type=script&lang=js&"
export * from "./BalanceRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports